module.exports = __webpack_public_path__ + "static/media/introduce-2.e86869a7.png";